import React from "react";
import Grid from "@material-ui/core/Grid";
import MyPagination from "Components/MyPagination";
import Tweet from "Components/Tweet";
import DatePickers from "Components/DatePickers";
import Layout from "Layout";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import PosiTabs from "Components/PosiTabs";
import OrderSelect from "Components/OrderSelect";
import { fromMonthly, toMonthly } from "fuction/date";
import useAuth from "Hooks/useAuth";
import useApi from "Hooks/useApi";
import useFilter from "Hooks/useFilter";
import { animateScroll as scroll } from 'react-scroll';
import googleAnalytics from "fuction/googleAnalytics";
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import Toolbar from '@material-ui/core/Toolbar';
import { makeStyles } from "@material-ui/core/styles";
import { useQueryString, modQueryPageNum, getQueryPageNum } from "Hooks/useQueryString";

const useStyles = makeStyles((theme) => ({
  divider: {
    display: "flex",
    alignItems: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
  },
  sticky: {
    position: "-webkit-sticky", /* safari対応 */
    position: "sticky",
    top: 64,
    zIndex: 1,
    backgroundColor: "white",
    paddingLeft: 110,
    paddingRight: 110,
  },
}));

export default function AllPosts(props) {
  const { request, convertQueryParam } = useApi();
  const auth = useAuth();
  const filter = useFilter();
  const classes = useStyles();
  const queryParams = useQueryString();
  const fromDate = fromMonthly(filter.state.filteredDateFrom);
  const toDate = toMonthly(filter.state.filteredDateTo);
  const [isHideImage, setIsHideImage] = React.useState(false);
  const [isWithImage, setIsWithImage] = React.useState(false);
  const [tweets, setTweets] = React.useState([]);
  const [page, setPage] = React.useState(getQueryPageNum(queryParams));
  const [totalCount, setTotalCount] = React.useState(0);
  const [retweetCount, setRetweetCount] = React.useState(0);
  const [order, setOrder] = React.useState("desc");

  const scrollToTop = () => {
    scroll.scrollToTop();
  }

  // ツイート情報を取得
  const rquestTweets = () => {
    // 戻るボタンやURL直貼りで遷移してきたとき、queryParams と auth.state の activeGroup が食い違っていても、
    // 初回レンダでは state の activeGroup （デフォルトグループ）でリクエストして返されたデータで一瞬画面表示されてしまい、
    // Layout.js で queryParams と auth.state の activeGroup の同期をとったあとで走る再レンダ時のリクエストで
    // 後からデータを取得して画面を上書きする動作が見えてしまうので、
    // 同期前で食い違いがあるうちはリクエストしない。
    const activeGroup = queryParams.get("activeGroup");
    if (activeGroup && auth.state.activeGroup !== parseInt(activeGroup, 10)) {
      return;
    }
    const requestFilter = {
      pn: filter.state.posiNegaTab,
    }
    if (isWithImage) {
      requestFilter.img = isWithImage;
    }
    request({
      method: "GET",
      url: `data/:account_id/tweets/${
        auth.state.activeGroup
      }/statuses?${convertQueryParam({
        range: [fromDate, toDate],
        filter: requestFilter,
        order: order,
        pagination: {
          page: page,
          limit: 50,
        },
      })}`,
    }).then((data) => {
      setTweets(data.data);
      setTotalCount(data.meta.total_count);
      setRetweetCount(data.meta.rt_count);
      scrollToTop()
    });
  }

  // 初回レンダリングフラグ
  const isFirstRender = React.useRef(false);
  React.useEffect(() => {
    // タイトル変更
    document.title = "Buzz Finder - 全ての投稿";
    isFirstRender.current = true;
  }, []);

  React.useEffect(() => {
    googleAnalytics(props.location.pathname, auth.state.user.account_id)
  }, [props.location.pathname]);

  React.useEffect(() => {
    // 初回レンダー判定
    if(isFirstRender.current) {
      // 初回レンダーではないように
      isFirstRender.current = false;
    } else {
      rquestTweets();
    }
  }, [page]);

  const syncQueryPageNum = (...[pn]) => {
    if ((pn && pn === 1) || (totalCount > 0 && (Math.ceil(totalCount / 50)) < getQueryPageNum(queryParams))) {
      modQueryPageNum(queryParams, 1);
      props.history.push(props.location.pathname + "?" + queryParams.toString());
      setPage(1);
    }
    else {
      setPage(getQueryPageNum(queryParams));
    }
  }

  React.useEffect(() => {
    if (auth.state.activeGroup === 0) {
      return;
    }

    if (page === 1) {
      rquestTweets();
    } else {
      syncQueryPageNum(1);
    }
  }, [auth.state.activeGroup, filter.state, isWithImage, order]);

  if (page !== getQueryPageNum(queryParams)) {
    syncQueryPageNum();
  }
  return (
    <Layout
      content={
        <Grid container direction="row" spacing={3} justifyContent="center">
          <Toolbar className={classes.sticky}>
            <Grid item xs={12}>
              <Grid
                container
                direction="row"
                alignItems="flex-end"
                justifyContent="flex-start"
              >
                <DatePickers />
                <div className={classes.divider}></div>
                <PosiTabs />
                <div className={classes.divider}></div>
                <OrderSelect
                  handleChangeOrderSelect={(value) => {
                    setOrder(value);
                  }}
                  value={order}
                  isRetweet={true}
                />
                <div className={classes.divider}></div>
                <FormControl component="fieldset" className={classes.formControl}>
                  <FormGroup>
                    <FormControlLabel
                      control={<Switch size="small" checked={isHideImage} onChange={(event) => setIsHideImage(event.target.checked)} name="isHideImage" />}
                      label="画像を表示しない"
                    />
                    <FormControlLabel
                      control={<Switch size="small" checked={isWithImage} onChange={(event) => setIsWithImage(event.target.checked)} name="isWithImage" />}
                      label="画像付きのみ表示"
                    />
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid container spacing={3} className={classes.formControl} justifyContent="center">
                <MyPagination
                count={Math.ceil(totalCount / 50)}
                currentPage={page}
                handlePagination={(page) => setPage(page)}
                />
              </Grid>
            </Grid>
          </Toolbar>
          <Grid item xs={12}>
            {tweets.map((row, index) => (
              <Tweet row={row} key={row.id_str} isHideImage={isHideImage} order={order} retweetCount={retweetCount[index]} />
            ))}
          </Grid>
        </Grid>
      }
    />
  );
}
